import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_410: DocMigration = {
  maxSchemaVersion: "0.0.410",
  description: "Add flags to presevere legacy behavior for gable and dormer window attachements",
  apply(json: any) {
    for (const id in json.gableOpenings) {
      json.gableOpenings[id].useLegacyAttachmentSettings = true;
    }

    for (const id in json.dormers) {
      if (json.dormers[id]) {
        json.dormers[id].dormerSettings = {
          ...json.dormers[id].dormerSettings,
          useLegacyAttachmentSettings: true,
        };
      }
    }

    return json;
  },
};

export default migration_0_0_410;
